Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};

Greenmile.PanelBuilder.TIME_MINUTES_SECONDS = (function () {

    function TIME_MINUTES_SECONDS (field, entity) {

        Greenmile.PanelBuilder.Fields.ComplexField.apply(this, arguments);

    };

    return TIME_MINUTES_SECONDS;

}());